module.exports = __webpack_public_path__ + "media/icons/plyny-menu-5fac37e6.png";